import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalysisListItemComponent } from '../../../../shared/analysis-list-item/analysis-list-item.component';
import { CommonModule } from '@angular/common';
import { Analysis } from '../../../../interfaces/analysis';
import { response } from 'express';

@Component({
  selector: 'app-analysis-dialog',
  standalone: true,
  imports: [CommonModule, AnalysisListItemComponent],
  templateUrl: './analysis-dialog.component.html',
  styleUrl: './analysis-dialog.component.css',
})
export class AnalysisDialogComponent {
  analysisList!: Analysis[];
  constructor(
    public dialogRef: MatDialogRef<AnalysisDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      response: any;
      sampleName: string;
    }
  ) {
    this.analysisList = this.data.response;
  }

  closePopup(): void {
    this.dialogRef.close();
  }
}
